import MODULE_TYPES from "@/constants/MODULE_TYPES"
import { BaseRoute } from "@/types/global"

const DetermineBaseRouteByOrganisationCategory = (
  orgCatgeory:
    | string
    | undefined
    | MODULE_TYPES.CONSULTANT
    | MODULE_TYPES.MANAGER
    | MODULE_TYPES.OWNER
):
  | BaseRoute
  | MODULE_TYPES.CONSULTANT
  | MODULE_TYPES.MANAGER
  | MODULE_TYPES.OWNER => {
  switch (orgCatgeory) {
    case "Consultant":
      return "consultant"
    case "Asset manager":
      return "manager"
    case "Asset owner":
      return "owner"
    case "Others":
      return "client"
    default:
      return "client"
  }
}

export default DetermineBaseRouteByOrganisationCategory
